module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/caterers2-e6d0a47d340586dec2e116a798834584.webp";